import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '@utils/cn';
const sizeStyles = {
    sm: 'h-4 w-4',
    md: 'h-8 w-8',
    lg: 'h-12 w-12',
};
export function Loading({ size = 'md', text, fullScreen = false, className }) {
    const spinner = (_jsxs("div", { className: cn('flex flex-col items-center justify-center gap-3', className), children: [_jsxs("svg", { className: cn('animate-spin text-primary-500', sizeStyles[size]), xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", children: [_jsx("circle", { className: "opacity-25", cx: "12", cy: "12", r: "10", stroke: "currentColor", strokeWidth: "4" }), _jsx("path", { className: "opacity-75", fill: "currentColor", d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" })] }), text && _jsx("p", { className: "text-sm text-gray-600", children: text })] }));
    if (fullScreen) {
        return (_jsx("div", { className: "fixed inset-0 z-50 flex items-center justify-center bg-white/80 backdrop-blur-sm", children: spinner }));
    }
    return spinner;
}
// 骨架屏组件
export function Skeleton({ className }) {
    return (_jsx("div", { className: cn('animate-pulse rounded-lg bg-gray-200', className) }));
}
// 骨架屏卡片
export function SkeletonCard() {
    return (_jsxs("div", { className: "card p-4", children: [_jsx(Skeleton, { className: "mb-3 aspect-video w-full" }), _jsx(Skeleton, { className: "mb-2 h-5 w-3/4" }), _jsx(Skeleton, { className: "h-4 w-1/2" })] }));
}
